<template>
  <div style="margin-top: 1rem;">
    <div class="nov-line first-line">
      <NovenaryFigure :figure-id="3" :is-editable="true" />
      <NovenaryFigure :figure-id="2" :is-editable="true" />
      <NovenaryFigure :figure-id="1" :is-editable="true" />
    </div>
    <div class="nov-line second-line">
      <NovenaryFigure :figure-id="5" :is-editable="false" />
      <NovenaryFigure :figure-id="4" :is-editable="false" />
    </div>
    <div style="position: relative;">
      <div style="margin: 0 auto;">
        <NovenaryFigure :figure-id="6" :is-editable="false" />
      </div>
      <div style="position: absolute; right: 0; top: 0;">
        <NovenaryFigure :figure-id="7" :is-editable="false" />
      </div>
    </div>
  </div>
</template>

<script>
import NovenaryFigure from "./NovenaryFigure";

export default {
  name: "Novenary",
  components: { NovenaryFigure }
};
</script>

<style lang="scss" scoped>
.nov-line {
  width: 24rem;
  display: flex;
}

.first-line {
  justify-content: space-between;
}

.second-line {
  justify-content: space-around;
}
</style>
